import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Card, CardHeader, CardBody, CardTitle, Row, Col, Table, Button, Pagination, PaginationItem, PaginationLink, Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Alert, Input } from "reactstrap";
import { AppContext } from "../../../AppContext";
import axios from "axios";
import { BASE_URL } from "../../../constants";

let apiTimeoutId = null;

function Users() {
	const [users, setUsers] = useState([]);
	const [currentPage, setCurrentPage] = useState(1);
	const [totalPages, setTotalPages] = useState(1);
	const [perPage, setPerPage] = useState(5);
	const [dropdownOpen, setDropdownOpen] = useState(false);
	const navigate = useNavigate();
	const [searchQuery, setSearchQuery] = useState("");
	const userData = JSON.parse(localStorage.getItem('userData'));
	const [errMsg, setErrMsg] = useState(null);

	useEffect(() => {
		if (apiTimeoutId) clearTimeout(apiTimeoutId);

		apiTimeoutId = setTimeout(() => {
			fetchData();
		}, 500);
	}, [currentPage, perPage, searchQuery]);

	const toggleDropdown = () => {
		setDropdownOpen(prevState => !prevState);
	};

	const fetchData = () => {
		const token = localStorage.getItem('token');
		if (token) {
			fetch(`${BASE_URL}/user/list?page_no=${currentPage}&per_page=${perPage}&q=${searchQuery}`, {
				headers: {
					Authorization: `Bearer ${token}`
				}
			})
				.then(response => response.json())
				.then(data => {
					console.log(data, 'data');
					if (data.status) {
						const formattedUsers = data.result.data.map(user => {
							const formattedUser = { ...user };
							formattedUser.created_at = new Date(user.created_at).toLocaleDateString('en-US');
							return formattedUser;
						});
						setUsers(formattedUsers);
						setTotalPages(data.result.meta_info.total_pages);
					} else {
						console.error("Error: Unable to fetch users data.");
					}
				})
				.catch(error => console.error("Error fetching data:", error));
		} else {
			console.error("Error: Authorization token is missing.");
		}
	};

	const handleSearchInputChange = (event) => {
		setSearchQuery(event.target.value);
	};
	

	const handlePageClick = (pageNumber) => {
		setCurrentPage(pageNumber);
	};

	const handlePerPageChange = (value) => {
		setPerPage(value);
		setCurrentPage(1);
	};

	const handleDeleteUser = async (id) => {

		const confirmed = window.confirm("Are you sure you want to delete this user?");

		if (confirmed) {
			try {
				const token = localStorage.getItem('token');
				if (!token) {
					throw new Error('Authorization token is missing.');
				}

				const response = await axios.delete(`${BASE_URL}/user/delete/${id}`, {
					headers: {
						Authorization: `Bearer ${token}`
					}
				});
				setErrMsg(response.data.message);
				fetchData();

			} catch (error) {
				setErrMsg(error);
			}
		}
	};

	const handleEditUser = (id) => {
		navigate(`/user/edit/${id}`, {
			state: {
				users: users
			}
		});
	};

	if (!userData) {
		return (
			<div className="content">Loading...</div>
		)
	}

	if (userData.type !== "OWNER") {
		return navigate('/dashboard');
	}

	return (
		<div className="content">
			{errMsg !== null && <Alert color="danger">{errMsg}</Alert>}

			<Row>
				<Col xs="6">
					<h4 className="mt-0">Users</h4>
				</Col>

				<Col xs="6" className="text-end">
					{
						userData?.type === "OWNER" &&
						<Button color="primary" onClick={() => navigate('/user/add')}>Add User</Button>
					}
				</Col>
			</Row>


			<Card>
				<CardBody>

					<Row className="my-3">
						<Col xs="12" className="text-end">
							<Input
								type="text"
								placeholder="Search by email"
								value={searchQuery}
								onChange={handleSearchInputChange}
								style={{ display: 'inline-block', width: 'auto', marginRight: '10px' }}
							/>
						</Col>
					</Row>

					<Table striped>
						<thead>
							<tr>
								<th>#</th>
								<th>Image</th>
								<th>First name</th>
								<th>Last name</th>
								<th>Email</th>
								<th>Phone</th>
								<th>Status</th>
								<th>Created at</th>
								<th className="text-center">Action</th>
							</tr>
						</thead>
						<tbody>
							{ users.length === 0 ? (
								<tr>
									<td colSpan="12" className="text-center">
										No users available.
									</td>
								</tr>
							) : (
									users.map((user, index) => (
										<tr key={index}>
											<td>{(currentPage - 1) * perPage + index + 1}</td>
											<td>
												{user.dp && (
													<img src={user.dp} alt="dp" style={{ width: '60px', height: 'auto' }} />
												)
												}
											</td>
											<td>{user.first_name}</td>
											<td>{user.last_name}</td>
											<td>{user.email}</td>
											<td>{user.phone}</td>
											<td>{user.status}</td>
											<td>{user.created_at}</td>
											<td className="text-end">
												<Button color="warning" size="sm" onClick={() => handleEditUser(user.id)}>Edit</Button>
												<span style={{ marginRight: "5px" }}></span>
												<Button color="danger" size="sm" onClick={() => handleDeleteUser(user.id)}>Delete</Button>
											</td>
										</tr>
									))
								)
							}
						</tbody>
					</Table>
				</CardBody>

				<Row>
					<Col xs="4">

						<div style={{ marginLeft: '25px' }}>
							<Dropdown isOpen={dropdownOpen} toggle={toggleDropdown}>
								<DropdownToggle caret color="primary">
									Per Page: {perPage}
								</DropdownToggle>
								<DropdownMenu>
									<DropdownItem onClick={() => handlePerPageChange(5)}>5</DropdownItem>
									<DropdownItem onClick={() => handlePerPageChange(10)}>10</DropdownItem>
									<DropdownItem onClick={() => handlePerPageChange(20)}>20</DropdownItem>
									<DropdownItem onClick={() => handlePerPageChange(50)}>50</DropdownItem>
								</DropdownMenu>
							</Dropdown>
						</div>
					</Col>

					<Col xs="8" className="text-right">
						<div style={{ display: 'flex', justifyContent: 'end', alignItems: 'end', marginRight: '25px', marginTop: '10px' }}>

							<Pagination aria-label="Page navigation example">
								<PaginationItem disabled={currentPage === 1}>
									<PaginationLink

										previous
										onClick={() => handlePageClick(currentPage - 1)}
									/>
								</PaginationItem>

								{currentPage > 3 && (
									<>
										<PaginationItem>
											<PaginationLink onClick={() => handlePageClick(1)}>
												1
											</PaginationLink>
										</PaginationItem>
										<PaginationItem disabled>
											<PaginationLink>...</PaginationLink>
										</PaginationItem>
									</>
								)}

								{Array.from({ length: 5 }, (_, i) => {
									const page = currentPage <= 3 ? i + 1 : currentPage - 2 + i;
									return (
										page <= totalPages && (
											<PaginationItem key={page} active={currentPage === page}>
												<PaginationLink

													onClick={() => handlePageClick(page)}
												>
													{page}
												</PaginationLink>
											</PaginationItem>
										)
									);
								})}

								{currentPage < totalPages - 2 && (
									<>
										<PaginationItem disabled>
											<PaginationLink>...</PaginationLink>
										</PaginationItem>
										<PaginationItem>
											<PaginationLink onClick={() => handlePageClick(totalPages)}>
												{totalPages}
											</PaginationLink>
										</PaginationItem>
									</>
								)}

								<PaginationItem disabled={currentPage === totalPages}>
									<PaginationLink

										next
										onClick={() => handlePageClick(currentPage + 1)}
									/>
								</PaginationItem>
							</Pagination>
						</div>
					</Col>
				</Row>

			</Card>

		</div>
	);
}

export default Users;
